module.exports = __webpack_public_path__ + "img/4_85.52dd8d38.png";